import { combineReducers } from 'redux'
import funGetprofile from './redux_login'
import funGetNotify from './redux_notify_state'
import funGetRnList_Redux from './redux_locatiion'
import counter from './counter'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['funGetprofile','funGetRnList_Redux'],
}

const rootReducer = combineReducers({
  funGetprofile,
  funGetNotify,
  funGetRnList_Redux,
  counter,
})

export default persistReducer(persistConfig, rootReducer)
